import { ArrowUpRight } from "lucide-react";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger,
} from "@/components/ui/dialog";

export function formatTournamentDate(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || "");
  return match ? `${match[3]}/${match[2]}/${match[1]}` : value || "A definir";
}

function formatFee(value) {
  if (!value) return null;
  const amount = Number(String(value).replace(",", "."));
  return Number.isFinite(amount)
    ? new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(amount)
    : value;
}

export default function TournamentDetailsDialog({ tournament, children, onOpenChange }) {
  const place = [tournament.location, tournament.city].filter(Boolean).join(" · ");
  const details = [
    ["Data", formatTournamentDate(tournament.date)],
    ["Horário", tournament.time || "A definir"],
    ["Local", place || "A definir"],
    ["Modalidade", tournament.modality],
    ["Categoria", tournament.category],
    ["Taxa de inscrição", formatFee(tournament.fee)],
    ["Prazo de inscrição", tournament.registration_deadline && formatTournamentDate(tournament.registration_deadline)],
  ].filter(([, value]) => value);
  const registrationLink = /^https?:\/\//i.test(tournament.registration_link || "")
    ? tournament.registration_link
    : null;

  return (
    <Dialog onOpenChange={onOpenChange}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="max-h-[85vh] max-w-xl overflow-y-auto border-amber-400/25 bg-[#0A203D] p-6 text-white shadow-[0_28px_80px_rgba(0,0,0,0.5)] sm:p-8">
        <DialogHeader className="pr-7 text-left">
          {tournament.featured && <span className="mb-2 w-fit rounded-md bg-amber-400 px-2.5 py-1 text-xs font-semibold text-[#071A33]">Destaque</span>}
          <DialogTitle className="text-2xl leading-tight text-white">{tournament.name}</DialogTitle>
          <DialogDescription className="text-sm text-slate-400">Informações do torneio</DialogDescription>
        </DialogHeader>

        <div className="grid gap-3 border-y border-amber-400/15 py-5 sm:grid-cols-2">
          {details.map(([label, value]) => (
            <div key={label} className="rounded-xl border border-amber-400/10 bg-[#102B4E] p-3.5">
              <p className="text-xs font-semibold uppercase tracking-wide text-amber-300">{label}</p>
              <p className="mt-1.5 break-words text-sm text-slate-100">{value}</p>
            </div>
          ))}
        </div>

        {tournament.info && (
          <div>
            <h3 className="text-sm font-semibold text-white">Sobre o torneio</h3>
            <p className="mt-2 whitespace-pre-line text-sm leading-relaxed text-slate-300">{tournament.info}</p>
          </div>
        )}

        {registrationLink && (
          <a href={registrationLink} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-11 items-center justify-center gap-2 rounded-lg bg-amber-500 px-5 py-2.5 text-sm font-semibold text-[#071A33] transition-colors hover:bg-amber-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-400">
            Fazer inscrição <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </a>
        )}
      </DialogContent>
    </Dialog>
  );
}
